import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/config/store';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import { Route } from 'react-router-dom';
import ParticleArrangementForm from 'app/edozvola/cases/particle-arrangement/particle-arrangement-form';
import PlannedDocumentationForm from 'app/edozvola/cases/planned-documentation/planned-documentation-form';
import CaseTabNotImplemented from 'app/shared/error/case-tab-not-implemented';
import PreviousDocuments from 'app/edozvola/cases/previous-documents/previous-documents';
import CaseAttachment from 'app/edozvola/cases/case-attachment/case-attachment';
import CaseFinalActOtherInfoForm from 'app/edozvola/cases/case-final-act-other-info-form/case-final-act-other-info-form';
import CaseAuthorityForm from 'app/edozvola/cases/case-authority-form/case-authority-form';
import CaseModeratorsForm from 'app/edozvola/cases/case-moderators-form/case-moderators-form';
import CaseExecutabilityValidityForm from 'app/edozvola/cases/case-executability-validity-form/case-executability-validity-form';
import CaseArchiveForm from 'app/edozvola/cases/case-archive-form/case-archive-form';
import CaseAdministrativeFeeForm from 'app/edozvola/cases/case-administrative-fee-form/case-administrative-fee-form';
import CaseRequestInfoForm from 'app/edozvola/cases/case-request-info-form/case-request-info-form';
import AttachmentPageForm from 'app/edozvola/cases/request-attachments/request-attachment-page';
import CreateNewAttachment from 'app/edozvola/cases/request-attachments/create-new-request-attachment';
import CaseApplicant from 'app/edozvola/cases/case-applicant/case-applicant';
import CaseFinalDocumentForm from 'app/edozvola/cases/case-final-document/case-final-document';
import CaseAppealForm from 'app/edozvola/cases/case-appeal/case-appeal-form';
import ProjectDocuments from 'app/edozvola/cases/project-documents/project-documents';
import RequestAdmission from 'app/edozvola/cases/request-admission/request-admission';
import FinalDocumentAdmission from 'app/edozvola/cases/final-document-admission/final-document-admission';
import CaseBuildingPlotForm from 'app/edozvola/cases/case-building-plot/case-building-plot-form';
import CaseConstructionLegalityForm from 'app/edozvola/cases/case-construction-legality/case-construction-legality-form';
import Parties from 'app/edozvola/cases/parties/parties';
import CaseMainProjectDocuments from 'app/edozvola/cases/case-main-project-documents/case-main-project-documents';
import AddedPerson from 'app/edozvola/cases/added-person/added-person';
import SpecialBuildingPart from 'app/edozvola/cases/special-building-part/special-building-part';
import LocationPermitCompliance from 'app/edozvola/cases/location-permit-compliance/location-permit-compliance';
import CaseLegalRemedyForm from 'app/edozvola/cases/case-legal-remedy-form/case-legal-remedy-form';
import CaseTechnicalInspection from 'app/edozvola/cases/case-technical-inspection/case-technical-inspection';
import FiledLawsuit from 'app/edozvola/cases/filed-lawsuit/filed-lawsuit';
import CaseSegment from 'app/edozvola/cases/case-segment/case-segment';
import DeliveryOrder from 'app/edozvola/cases/delivery-order/delivery-order';
import ConstructionParticipants from 'app/edozvola/cases/construction-participants/construction-participants';
import CaseLocation from 'app/edozvola/cases/case-location/case-location';

import CaseZoningPlanCompliance from 'app/edozvola/cases/case-zoning-plan-compliance/case-zoning-plan-compliance';
import CaseCaseRegistry from 'app/edozvola/cases/case-case-registry-form/case-case-registry';
import CaseRevision from 'app/edozvola/cases/case-revision/case-revision';
import RouterPreloadData from 'app/shared/router-preload-data/router-preload-data';
import { fetchMainProjectDocumentVariantQuery } from 'app/edozvola/cases/case-main-project-documents/service/case-main-project-documents.queries';
import AmendmentActs from 'app/edozvola/cases/case-acts/amendment-acts';
import PhasedConstructionMain from 'app/edozvola/cases/phased-construction/phased-construction-main';
import ConstructionBuildingProcedure from 'app/edozvola/cases/construction-building-procedure/construction-building-procedure';
import ConstructionFee from 'app/edozvola/cases/construction-fee/construction-fee';
import SpecialRegulationsCompliance from 'app/edozvola/cases/special-regulations-compliance/special-regulations-compliance';
import CaseFormPreviewWrapper from 'app/edozvola/case-form-preview-wrapper';
import PreviewActs from 'app/edozvola/cases/case-acts/preview-acts';
import { fetchApplicantsVariantQuery } from 'app/edozvola/cases/case-applicant/service/case-applicant.queries';
import { fetchProjectDocumentVariantQuery } from 'app/edozvola/cases/project-documents/service/project-document.queries';
import { getCaseRegistryVariantQuery } from '../case-case-registry-form/service/case-registry.queries';
import { fetchConstructionBuildingProcedureVariantQuery } from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';

const CasesPreviewRoutes = () => {
  return (
    <ErrorBoundaryRoutes>
      <Route path=":id">
        <Route index element={<CaseFormPreviewWrapper children={null} />} />
        <Route
          path="acts"
          element={
            <CaseFormPreviewWrapper>
              <PreviewActs />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="amendment-acts"
          element={
            <CaseFormPreviewWrapper>
              <AmendmentActs />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="authority"
          element={
            <CaseFormPreviewWrapper>
              <CaseAuthorityForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="moderators"
          element={
            <CaseFormPreviewWrapper>
              <CaseModeratorsForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="case-registry"
          element={
            <CaseFormPreviewWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => getCaseRegistryVariantQuery(uuid, true)}>
                <CaseCaseRegistry />
              </RouterPreloadData>
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="request-admission"
          element={
            <CaseFormPreviewWrapper>
              <RequestAdmission />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="request-info"
          element={
            <CaseFormPreviewWrapper>
              <CaseRequestInfoForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="final-document-act"
          element={
            <CaseFormPreviewWrapper>
              <CaseFinalDocumentForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="appeal"
          element={
            <CaseFormPreviewWrapper>
              <CaseAppealForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="executability-validity"
          element={
            <CaseFormPreviewWrapper>
              <CaseExecutabilityValidityForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="archive"
          element={
            <CaseFormPreviewWrapper>
              <CaseArchiveForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="administrative-fee"
          element={
            <CaseFormPreviewWrapper>
              <CaseAdministrativeFeeForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="legal-remedy"
          element={
            <CaseFormPreviewWrapper>
              <CaseLegalRemedyForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="building-plot"
          element={
            <CaseFormPreviewWrapper>
              <CaseBuildingPlotForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="construction-legality"
          element={
            <CaseFormPreviewWrapper>
              <CaseConstructionLegalityForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="phased-construction"
          element={
            <CaseFormPreviewWrapper>
              <PhasedConstructionMain />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="final-act-other-info"
          element={
            <CaseFormPreviewWrapper>
              <CaseFinalActOtherInfoForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="request-attachments"
          element={
            <CaseFormPreviewWrapper>
              <CaseAttachment />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="previous-documents"
          element={
            <CaseFormPreviewWrapper>
              <PreviousDocuments />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="project-documents"
          element={
            <CaseFormPreviewWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchProjectDocumentVariantQuery(uuid, true)}>
                <ProjectDocuments />
              </RouterPreloadData>
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="main-project-documents"
          element={
            <CaseFormPreviewWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchMainProjectDocumentVariantQuery(uuid, true)}>
                <CaseMainProjectDocuments />
              </RouterPreloadData>
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="applicants"
          element={
            <CaseFormPreviewWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchApplicantsVariantQuery(uuid, true)}>
                <CaseApplicant />
              </RouterPreloadData>
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="attachments"
          element={
            <CaseFormPreviewWrapper>
              <AttachmentPageForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="final-document-admission"
          element={
            <CaseFormPreviewWrapper>
              <FinalDocumentAdmission />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="attachments/:idAttachment"
          element={
            <CaseFormPreviewWrapper>
              <CreateNewAttachment />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="construction-building-procedure"
          element={
            <CaseFormPreviewWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchConstructionBuildingProcedureVariantQuery(uuid, true)}>
                <ConstructionBuildingProcedure />
              </RouterPreloadData>
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="construction-participants"
          element={
            <CaseFormPreviewWrapper>
              <ConstructionParticipants />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="location"
          element={
            <CaseFormPreviewWrapper>
              <CaseLocation />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="parties"
          element={
            <CaseFormPreviewWrapper>
              <Parties />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="added-person"
          element={
            <CaseFormPreviewWrapper>
              <AddedPerson />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="special-building-part"
          element={
            <CaseFormPreviewWrapper>
              <SpecialBuildingPart />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="location-permit-compliance"
          element={
            <CaseFormPreviewWrapper>
              <LocationPermitCompliance />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="final-document-admission"
          element={
            <CaseFormPreviewWrapper>
              <FinalDocumentAdmission />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="particle-arrangement"
          element={
            <CaseFormPreviewWrapper>
              <ParticleArrangementForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="planned-documentation"
          element={
            <CaseFormPreviewWrapper>
              <PlannedDocumentationForm />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="technical-inspection"
          element={
            <CaseFormPreviewWrapper>
              <CaseTechnicalInspection />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="construction-administrative-fee"
          element={
            <CaseFormPreviewWrapper>
              <ConstructionFee />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="filed-lawsuit"
          element={
            <CaseFormPreviewWrapper>
              <FiledLawsuit />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="segmentation"
          element={
            <CaseFormPreviewWrapper>
              <CaseSegment />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path={'zoning-plan-compliance'}
          element={
            <CaseFormPreviewWrapper>
              <CaseZoningPlanCompliance />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path={'delivery-order'}
          element={
            <CaseFormPreviewWrapper>
              <DeliveryOrder />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path={'special-regulations-compliance'}
          element={
            <CaseFormPreviewWrapper>
              <SpecialRegulationsCompliance />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="case-revision"
          element={
            <CaseFormPreviewWrapper>
              <CaseRevision />
            </CaseFormPreviewWrapper>
          }
        />
        <Route
          path="*"
          element={
            <CaseFormPreviewWrapper>
              <CaseTabNotImplemented />
            </CaseFormPreviewWrapper>
          }
        />
      </Route>
    </ErrorBoundaryRoutes>
  );
};

const mapStateToProps = ({}: IRootState) => ({});

export default connect(mapStateToProps, null)(CasesPreviewRoutes);
